module.exports = __webpack_public_path__ + "img/capacitor-excited.3186e31f.jpg";